import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FormApiService } from './formapiService';

/**
 * Caches the participant profile response so only one /api/auth/profile call
 * is made per session. Clear cache on logout/session clear.
 */
@Injectable({
  providedIn: 'root'
})
export class ProfileCacheService {
  private readonly api = inject(FormApiService);
  private cached: any = null;

  getProfile(): Observable<any> {
    if (this.cached !== null) {
      return of(this.cached);
    }
    return this.api.getProfile().pipe(
      tap((response) => { this.cached = response; })
    );
  }

  clearCache(): void {
    this.cached = null;
  }
}
